<template lang="pug">
Fragment
  .span-full
    div.head.no-print
      .d-flex
        b-icon.no-print.mr-2(icon="clipboard" variant="dark" font-scale="1.5")
        h4.mb-0.title.no-print Ingreso del Equipo
      .no-print(v-if="!printNoDisplay" :style="printNoDisplay ? '' : 'display:none;'")
        router-link(:to="`/editar-orden/${ot.ot}`")
          b-icon(icon="pencil")
    hr.no-print.ot-divider
  div.details
      .d-flex.gap-2
        label.is-primary R.M.A
        b-icon.cursor-pointer(v-if="ot.rma && isAdmin" icon="pencil-square" font-scale="1.5" variant="dark" @click="showEditRMAModal")
        ActionEditRMA.d-none(:ot="ot" noButton ref="actionEditRMA")
      VueBarcode(v-bind:value="ot.rma" width=1 height=30 textAlign="center" fontSize="15")
  div.details(v-if="ot.cliente.tipo_cliente==='Empresa'")
      label.input-label Guia de despacho de ingreso
      span.display-data {{ot.guia_despacho_ingreso}}
  div.details
      label.input-label Tipo de despacho
      span.display-data {{ tipoDespacho }}
  div.details
      label.input-label Fecha de ingreso
      span.display-data {{fechaIngreso | beautyDate}}
  div.details
      label.input-label Servicio Requerido
      span(id="servicio-requerido-text").display-data {{ot.tipo_servicio.nombre}}
  div.details(v-if="ot.tipo_de_falla")
      label.input-label Tipos de falla
      span(id="servicio-requerido-text").display-data {{ot.tipo_de_falla}}
  div.details
      label.input-label Otros accesorios
      span.display-data {{ot.otros_accesorios}}
  div.details
      label.input-label ¿Cliente exige cambio o 3x3?
      span.display-data {{ot.exige_cambio_3x3 ? 'Sí' : 'No'}}
  div.details.span-full-screen
      label.input-label Reporte de la falla
      span.display-data {{ot.reporte_falla_cliente}}
  div.details.span-full-screen
      label.input-label Observaciones
      span.display-data {{ot.observaciones}}
  //- SILL-1533: acceso a las respuestas del cuestionario de falla, sólo cuando
  //- el cliente ya lo respondió. Cierra la sección, como en el diseño.
  div.span-full-screen.no-print(v-if="formularioFallaCompletado")
      FormularioFallaRespuestas(:ot-id="ot.ot")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import VueBarcode from 'vue-barcode'
import hasPermissions from '@/utils/permissions'
import { LABEL_TIPO_DESPACHO } from '@/utils/labels'
import ActionEditRMA from '@/components/OT/OTActions/ActionEditRMA.vue'
import FormularioFallaRespuestas from '@/components/OT/ViewOT/FormularioFallaRespuestas.vue'

export default {
  name: 'EnteredEquipment',
  components: { VueBarcode, ActionEditRMA, FormularioFallaRespuestas },
  data() {
    return {
      editing: false,
      estados: [],
    }
  },
  created() {
    this.getOtHistory(this.ot.ot).then((res) => {
      this.estados = res.data
    })
  },
  computed: {
    ...mapGetters('OTStore', ['ot', 'printNoDisplay']),
    fechaIngreso() {
      const fechas = this.estados
        .filter((s) => s.estado.nombre === 'Ingresado')
        .map((f) => f.fecha_hora)

      return fechas.length > 0 ? fechas[0] : null
    },

    tipoDespacho() {
      return LABEL_TIPO_DESPACHO[
        this.ot?.despacho || this.ot?.sucursal?.despacho
      ]
      // eslint-disable-next-line
      // if (this.ot.despacho || this.ot.sucursal?.despacho) {
      //   if (
      //     this.ot?.sucursal?.despacho === 'ENVIO' ||
      //     this.ot.despacho === 'ENVIO'
      //   ) {
      //     return 'Envio'
      //   }
      //   if (
      //     this.ot?.sucursal?.despacho === 'RETIRO' ||
      //     this.ot.despacho === 'RETIRO'
      //   ) {
      //     return 'Retiro por cliente'
      //   }
      //   if (
      //     this.ot?.sucursal?.despacho === 'COORD_CLIENTE' ||
      //     this.ot.despacho === 'COORD_CLIENTE'
      //   ) {
      //     return 'Coordinado por cliente'
      //   }
      // }
    },

    /** SILL-1533: sólo se ofrecen las respuestas si el cliente ya respondió. */
    formularioFallaCompletado() {
      return Boolean(this.ot?.formulario_falla?.completado)
    },

    isAdmin() {
      const { user } = JSON.parse(localStorage.getItem('user'))
      return hasPermissions({
        roles: ['Administrativo'],
        user: { user },
      })
    },
  },
  methods: {
    ...mapActions('OT', ['getOtHistory']),

    showEditRMAModal() {
      this.$refs.actionEditRMA.showModal()
    },
  },
  filters: {
    beautyDate(date) {
      //eslint-disable-line
      if (date) {
        const momentDate = moment(date)
        return momentDate.isValid()
          ? momentDate.format('DD/MM/YYYY')
          : 'Fecha no disponible'
      }
      return 'Fecha no disponible'
    },
  },
}
</script>

<style lang="scss" scoped>
.is-primary {
  color: #1d4ed8;
  font-weight: bold;
  font-size: 1em;
}
.ot-divider {
  border-top: 1.5px solid #23201c;
}
.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
}
.title {
  color: #23201c;
  font-weight: 700;
  font-size: 1.2em;
}
.sub-title {
  color: #23201c;
  font-weight: 700;
  font-size: 1em;
}
.input-label {
  color: #525252;
  font-weight: bold;
  font-size: 1em;
}
.display-data {
  color: #525252;
  font-size: 1em;
}
.details {
  display: flex;
  flex-direction: column;
}
p {
  font-size: 15px;
}
.title2 {
  color: #253590;
  font-weight: bold;
  font-style: 15px;
}
</style>
